import { useDataAccumulatorForSingleOrder } from "../../../context/dataAccumulatorForSingleOrder";
import { generateFullName } from "../../../utils/generateOrderDataForTable";
import ManageAttachments from "./manageAttachments";

interface PortalQuestionnaireHeaderProps {
  mergedPdfToRender: (file: File) => void;
}

const PortalQuestionnaireHeader = (props: PortalQuestionnaireHeaderProps) => {
  const { generalOrderDetails } = useDataAccumulatorForSingleOrder();
  const order = generalOrderDetails?.order ?? null;
  return (
    <div className="portal-questionnaire-header flex w-full items-center justify-between">
      <div className="portal-questionnaire-header left-section flex items-center gap-2">
        <div className="portal-questionnaire-header main-title text-h11 font-bold text-primaryGray-1">
          {generateFullName(
            order?.demographics?.first_name ?? "",
            "",
            order?.demographics?.last_name ?? "",
          )}
        </div>
        <div className="portal-questionnaire-header sub-title text-h12 text-primaryGray-1">
          {`(${order?.demographics?.patient_mrn ?? ""})`}
        </div>
      </div>
      <div className="portal-questionnaire-header right-section">
        <ManageAttachments mergedPdfToRender={props.mergedPdfToRender} />
      </div>
    </div>
  );
};

export default PortalQuestionnaireHeader;
